module.exports = __webpack_public_path__ + "img/result_hot.70961251.jpg";